export const SoldDataShareFormControlName = {
  Name: 'name',
  Email: 'email',
};

export default {
  SoldDataShareFormControlName,
};
